import { quickOrderProductListStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import { css } from "styled-components";

quickOrderProductListStyles.totalText = {
    variant: "p",
    size: 15,
    weight: "bold",
    css: css`
        margin: 15px 0;
        text-align: end;
    `,
};
